module.exports = __webpack_public_path__ + "static/media/sc3.948e39b4.png";